import React from 'react';
import { Link } from 'react-router-dom';
import JobCard from './JobCard';

const JobListings = () => {
  // Simulating the scenario where there are no job openings
  const jobs = []; // Empty array representing no current job openings

  return (
    <section className="p-4 sm:p-6 lg:p-8">
      <div className="flex flex-col sm:flex-row justify-between items-center mb-4 sm:mb-6">
        <h2 className="text-center text-2xl sm:text-3xl font-bold text-center sm:text-left mb-4 sm:mb-0">Current Openings</h2>
      </div>

      {/* Check if there are any job openings */}
      {jobs.length === 0 ? (
        <div className="text-center py-12 sm:py-20 px-4">
          <h3 className="text-lg sm:text-xl font-semibold mb-3">No Current Job Openings</h3>
          <p className="text-gray-600 mb-6">We don't have any open positions at the moment, but we’re always looking for great talent!</p>
          <Link
            to={`/apply?title=${encodeURIComponent('Future Opportunity')}&description=${encodeURIComponent('Express your interest in future opportunities with our company.')}`}
            className="text-blue-500 underline mt-2 block"
          >
            Apply for Future Opportunities
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {jobs.map((job, index) => (
            <div key={index} className="flex flex-col items-center sm:items-start">
              <JobCard title={job.title} description={job.description} type={job.type} location={job.location} />
              <Link
                to={`/apply?title=${encodeURIComponent(job.title)}&description=${encodeURIComponent(job.description)}`}
                className="text-blue-500 underline mt-2 block text-center sm:text-left"
              >
                Apply Now
              </Link>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default JobListings;
